module.exports = __webpack_public_path__ + "static/media/workInProgress.8b019332.png";